import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import TableRox from 'src/components/table-rox/TableRox';
import { useFaq } from './faq.hook';
import { paths } from 'src/routes/paths';
import CNLoading from 'src/components/loading-cn/CNLoading';
import { useMyDataStore } from 'src/store/me/me.store';

export default function Faq() {
  const hook = useFaq();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.personalization)

  return (
    <Page title="FAQ">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          links={[]}
          heading="FAQ"
          action={
            <Button variant="contained" onClick={() => hook.navigate(paths.dashboard.faqCreate)} disabled={!permissions?.create}>
              Cadastrar Pergunta
            </Button>
          }
        />
        {hook.isLoadingFaqList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={hook.faqList}
            header={hook.TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => hook.navigate(paths.dashboard.faqDetails(id))}
            selectKey="_id"
          />
        )}
      </Container>
    </Page>
  );
}
